export type QuestAction = "previewOrCancel" | "primary" | "continue" | "pause";

export interface QuestControlDescriptor {
  readonly handedness: XRHandedness;
  readonly componentId: string;
  readonly componentType: string;
  readonly isMainComponent: boolean;
}

export function mapQuestControl(descriptor: QuestControlDescriptor): QuestAction | null {
  const id = descriptor.componentId.toLowerCase();
  const hand = descriptor.handedness;

  if (hand === "left" && (descriptor.isMainComponent || descriptor.componentType === "trigger")) return "previewOrCancel";
  if (hand === "right" && (descriptor.isMainComponent || descriptor.componentType === "trigger")) return "primary";
  if (hand === "left" && (id.includes("x-button") || id === "x" || id === "button-4")) return "previewOrCancel";
  if (hand === "left" && (id.includes("y-button") || id === "y" || id === "button-5")) return "pause";
  if (hand === "right" && (id.includes("a-button") || id === "a" || id === "button-4")) return "primary";
  if (hand === "right" && (id.includes("b-button") || id === "b" || id === "button-5")) return "continue";
  return null;
}
